import React from 'react';
import { useSelector } from 'react-redux';

const ResourceRow = ({ content }) => {
  return (
    <div className="course-resource__row">
      <img
        src={'/images/courses/resourcePdf.png'}
        alt="rsc-icon"
        className="course-resource__icon"
      />
      <div className="course-resource__content">
        <p className="course-resource__name">{content.title}</p>
      </div>
      <div
        className="course-resource__btn"
        onClick={(e) => {
          window.open(content.media_url, '_blank');
        }}
      >
        <img alt="" src="/images/courses/downloadrsc.png" className="course-resource__icon-dl" />
        <p className="course-resource__desc__bold">Download</p>
      </div>
    </div>
  );
};

const CourseResource = () => {
  const course_ebook = useSelector((state) => state.course_ebook);
  return (
    <>
      <div className="course-resource">
        <h1 className="course-resource__title mb-4">E-book Kelas</h1>
        {course_ebook
          ? course_ebook[0]
            ? course_ebook.map((el) => <ResourceRow content={el} />)
            : ''
          : ''}
      </div>
    </>
  );
};

export default CourseResource;
